import React, { useEffect, useState } from "react";
import CourseCard from "../layouts/CourseCard";
import WelcomeMessage from "../layouts/WelcomeMessage";
import api from "../services/api";

export default function StudentProfile() {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Static notices data - can be moved to API later
  const noticesData = [
    {
      id: 1,
      type: "urgent",
      title: "Fee Payment Deadline",
      message:
        "All outstanding fees must be paid by December 31st, 2024. Failure to pay may result in suspension of academic services.",
      badge: "URGENT",
      postedDate: "December 10, 2024",
      validUntil: "December 31, 2024",
      department: null,
      icon: "!",
      colorScheme: {
        bg: "bg-red-50",
        border: "border-red-400",
        iconBg: "bg-red-100",
        iconText: "text-red-600",
        titleText: "text-red-800",
        messageText: "text-red-700",
        badgeBg: "bg-red-100",
        badgeText: "text-red-600",
        metaText: "text-red-600",
      },
    },
  ];

  useEffect(() => {
    let isMounted = true;

    const fetchStudentProfile = async () => {
      try {
        const authToken = sessionStorage.getItem("token");

        if (!authToken) {
          console.log("No auth token found");
          setLoading(false);
          return;
        }

        const response = await api({
          url: `/api/user/student/profile`,
          method: "GET",
          headers: { Authorization: `Bearer ${authToken}` },
        });

        if (isMounted && response.status === 200) {
          setProfileData(response.data.data);
        }
      } catch (error) {
        if (isMounted) {
          console.log("Error fetching student profile:", error.message);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchStudentProfile();

    // Cleanup function to prevent state updates if component unmounts
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="w-full bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="container mx-auto px-4 py-8 pb-20 max-w-7xl min-h-screen">
        {loading ? (
          <div className="w-full flex items-center justify-center min-h-[400px]">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
              <p className="text-gray-600 text-lg">Loading your profile...</p>
            </div>
          </div>
        ) : profileData ? (
          <div className="space-y-8">
            {/* Header Section */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8">
              <div className="flex items-center space-x-6">
                <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white text-2xl font-bold">
                  {profileData.full_name.charAt(0)}
                </div>
                <div>
                  <h1 className="text-3xl font-bold text-gray-900 mb-2">
                    Welcome back, {profileData.full_name.split(" ")[0]}!
                  </h1>

                  <div className="flex items-center mt-2">
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-medium ${
                        profileData.status === 1
                          ? "bg-green-100 text-green-800"
                          : "bg-red-100 text-red-800"
                      }`}
                    >
                      {profileData.status === 1 ? "● Active" : "● Inactive"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Notice Section */}
            {/* <div>
              <div className="flex items-center mb-6">
                <div className="w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center mr-3">
                  <span className="text-amber-600 text-lg">📢</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900">Notices</h2>
              </div>
              <div className="space-y-4">
                {noticesData.map((notice) => (
                  <div
                    key={notice.id}
                    className={`${notice.colorScheme.bg} border-l-4 ${notice.colorScheme.border} rounded-lg p-6 shadow-sm`}
                  >
                    <div className="flex items-start">
                      <div className="flex-shrink-0">
                        <div
                          className={`w-8 h-8 ${notice.colorScheme.iconBg} rounded-full flex items-center justify-center`}
                        >
                          <span
                            className={`${
                              notice.colorScheme.iconText
                            } text-sm ${
                              notice.type === "urgent" ? "font-bold" : ""
                            }`}
                          >
                            {notice.icon}
                          </span>
                        </div>
                      </div>
                      <div className="ml-4 flex-1">
                        <div className="flex items-center justify-between mb-2">
                          <h3
                            className={`text-lg font-semibold ${notice.colorScheme.titleText}`}
                          >
                            {notice.title}
                          </h3>
                          <span
                            className={`text-xs ${notice.colorScheme.badgeText} ${notice.colorScheme.badgeBg} px-2 py-1 rounded-full`}
                          >
                            {notice.badge}
                          </span>
                        </div>
                        <p className={`${notice.colorScheme.messageText} mb-3`}>
                          {notice.message}
                        </p>
                        <div
                          className={`flex items-center text-sm ${notice.colorScheme.metaText}`}
                        >
                          <span>📅 Posted: {notice.postedDate}</span>
                          {notice.validUntil && (
                            <>
                              <span className="mx-2">•</span>
                              <span>Valid until: {notice.validUntil}</span>
                            </>
                          )}
                          {notice.department && (
                            <>
                              <span className="mx-2">•</span>
                              <span>{notice.department}</span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div> */}

            {/* Personal Information Cards */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-6">
                Personal Information
              </h2>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Personal Details Card */}
                <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-6">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                      <span className="text-blue-600 text-xl">👤</span>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900">
                      Personal Details
                    </h3>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <p className="text-sm text-gray-500 mb-1">Full Name</p>
                      <p className="font-medium text-gray-900">
                        {profileData.full_name}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500 mb-1">
                        Date of Birth
                      </p>
                      <p className="font-medium text-gray-900">
                        {new Date(profileData.dob).toLocaleDateString()}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500 mb-1">Gender</p>
                      <p className="font-medium text-gray-900">
                        {profileData.gender}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500 mb-1">National ID</p>
                      <p className="font-medium text-gray-900">
                        {profileData.national_id}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500 mb-1">Phone Number</p>
                      <p className="font-medium text-gray-900">
                        {profileData.phone}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500 mb-1">
                        Email Address
                      </p>
                      <p className="font-medium text-gray-900 break-words">
                        {profileData.email}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Academic Information Card */}
                <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-6">
                    <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4">
                      <span className="text-purple-600 text-xl">🎓</span>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900">
                      Academic Information
                    </h3>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <p className="text-sm text-gray-500 mb-1">
                        Registration Date
                      </p>
                      <p className="font-medium text-gray-900">
                        {new Date(
                          profileData.registration_date
                        ).toLocaleDateString()}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500 mb-1">
                        Account Status
                      </p>
                      <div className="flex items-center">
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium ${
                            profileData.status === 1
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}
                        >
                          {profileData.status === 1 ? "● Active" : "● Inactive"}
                        </span>
                      </div>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500 mb-1">Branch</p>
                      <p className="font-medium text-gray-900">
                        {profileData.branch_name}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500 mb-1">
                        Total Courses
                      </p>
                      <p className="font-medium text-gray-900">
                        {profileData.courses?.length || 0}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Course Information Section */}
            <div>
              <div className="flex items-center mb-6">
                <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center mr-3">
                  <span className="text-indigo-600 text-lg">📚</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900">
                  Course Information
                </h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {profileData.courses.map((course, index) => (
                  <CourseCard
                    key={index}
                    admissionNumber={course.admission_no}
                    courseName={course.course_name}
                    intake={course.intake.split(" ")[0]}
                    feeBalance={course.invoice.amount_due}
                  />
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="flex items-center justify-center min-h-[400px]">
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-red-600 text-2xl">⚠️</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Error Loading Profile
              </h3>
              <p className="text-gray-600">
                We couldn't load your profile data. Please try refreshing the
                page.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
